import { Logtail } from "@logtail/browser";
import { env } from "@/env";

export const logger = new Logtail(env.LOGTAIL_SOURCE_TOKEN);
